exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".space {\n  margin:0px 2px;\n}\n.control-panel-form input[type=\"submit\"] {\n  cursor: pointer !important;\n  background: #00ce7d !important;\n  color:#fff !important;\n  padding: 8px 15px 8px 15px !important;\n  border: 1px solid #00ce7d !important;\n}\n", ""]);

// exports
